import { useQuery } from "@tanstack/react-query";

import type { CrmEnrichmentJobPriceDto } from "../../../../types/types";
import sfEnrichmentApiService from "../../services/api/sfEnrichmentApiService";
import { salesforceEnrichmentQueryKeys } from "../key-factory";

const useSfEnrichmentJobPriceQuery = (fields: CrmEnrichmentJobPriceDto) => {
    return useQuery({
        enabled: fields.length > 0,
        queryKey: salesforceEnrichmentQueryKeys.estimatedPrice(fields),
        queryFn() {
            return sfEnrichmentApiService.getEstimatedPrice(fields);
        },
    });
};

export default useSfEnrichmentJobPriceQuery;
